import React from "react"
import styled from "styled-components"
import { replace, get, filter, isNull } from "lodash"
import { Button as AntdButton } from "antd"
import { FormNavigationContext } from "../../../Panes/Form"
import { media } from "../../../../components/mediaStylesNew"
import { colors } from "../../../../components/Color"
import SanityButton from "../../../../components/SanityButton"

const LoadingSection = styled.div`
  text-align: center;
  font-family: GT America, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const Title = styled.div`
  font-size: 30px;
  width: 100%;
  font-family: Recife Text, serif;
  margin-top: 40px;
`
const Subtitle = styled.div`
  width: 100%;
  font-size: 25px;
  margin-bottom: 20px;
  margin-left: 40px;
  font-family: GT America, sans-serif;
`

const TextBlocks = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 40px;
`

const TextBlock = styled.div`
  ${media.small`  
    width: 100%;
    text-align: justify;
    margin-top: 10px;
    font-size: 16px;

  `};

  width: 50%;
  padding-right: 10px;
  padding-left: 10px;
`

const Button = styled(SanityButton)``
const CallToAction = styled.div`
  width: 100%;

  button {
    margin-top: 20px;
    height: 40px;
    margin-bottom: 10px;
    background: ${colors.teal} !important;
    &:hover {
      background: white !important;
    }
  }
  h1,
  div {
    font-size: 20px !important;
    padding: 5px;
  }

  ${media.small`
    text-align: left;
    padding-left: 10px;
  `}
`

const AdditionalInfo = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 50px;

  ${media.small`
  margin-bottom: 0px;
  flex-direction: column;
  `}
`;

const BackButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 2em;
`;

const BackButton = styled(AntdButton)`
  background-color: #008496;
  color: #FAF7F2;
  border: 1px solid #008496;
  height: 50px;
  font-size: 16px;
  font-family: GT America,sans-serif;
  line-height: 24px;
  padding: 0 3em;

  &:hover,
  &:focus {
    background-color: #9EB2B2;
    border-color: #9EB2B2;
    color: #FAF7F2;
  }
`;

export default class ResultView extends React.Component {
  state = {
    percentage: 0,
  }

  fillFormResults(text) {
    return replace(text, /(\${.*?})/g, variable => {
      const variableName = variable.replace(/\$|{|}/g, "")
      return get(this.context.result, variableName, "-")
    })
  }

  getTodoIdFromURL = () => {
    const params = new URL(window.location).searchParams;
    return params.get('todoId');
  }

  handleBackButtonClick = () => {
    window.location.assign('https://portal.hopkins.law');
  }

  render() {
    const callToActionValid = this.props.callToAction && filter(this.props.callToAction, (prop) => !isNull(prop)).length > 0;
    const todoId = this.getTodoIdFromURL();
    return (
      <LoadingSection>
        <Title
          dangerouslySetInnerHTML={{
            __html: this.fillFormResults(this.props.headline),
          }}
        />
        <Subtitle
          dangerouslySetInnerHTML={{
            __html: this.fillFormResults(this.props.subheadline),
          }}
        />
        <AdditionalInfo>
          <TextBlocks>
            {this.props.textblocks.map((block, index) => (
              <TextBlock
                key={`${this.props.question.identifier}-${index}`}
                dangerouslySetInnerHTML={{
                  __html: this.fillFormResults(block),
                }}
              />
            ))}
          </TextBlocks>
          {callToActionValid && (
            <CallToAction>
              <Button {...this.props.callToAction} />
            </CallToAction>
          )}
        </AdditionalInfo>
        {todoId && (
          <BackButtonContainer>
            <BackButton onClick={this.handleBackButtonClick}>Zur Startseite</BackButton>
          </BackButtonContainer>
        )}
      </LoadingSection>
    )
  }
}

ResultView.contextType = FormNavigationContext
